import React, { useEffect, useState } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { SnackbarProvider } from "./contexts/SnackbarContext";
import AppRoutes from "./routes";
import "./shared/styles/theme.css";

// import { requestForToken, onMessageListener } from "./Firebase";
import NotificationSnackbar from "./components/NotificationModal";

const App = () => {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  // useEffect(() => {
  //   // Initialize Firebase notifications
  //   requestForToken();
    
  //   const unsubscribe = onMessageListener()
  //     .then((payload) => {
  //       console.log("Foreground notification received:", payload);
  //       const message = payload?.notification?.body || "New notification received";
  //       setSnackbarMessage(message);
  //       setSnackbarOpen(true);
  //     })
  //     .catch((err) => console.log("onMessageListener error:", err));

  //   return () => unsubscribe;
  // }, []);

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <Router>
      <AuthProvider>
        <SnackbarProvider>
          <AppRoutes />

          {/* Global Snackbar for foreground notifications */}
          <NotificationSnackbar
            open={snackbarOpen}
            handleClose={handleSnackbarClose}
            message={snackbarMessage}
          />
        </SnackbarProvider>
      </AuthProvider>
    </Router>
  );
};

export default App;